<div class="flex flex-col gap-2" [formGroup]="pharmacyForm()">
  <label for="pharmacyAddressRegion" class="text-[14px] font-[500] hover:cursor-pointer" i18n="@@pharmacyAddressRegion">
    Region
    <span class="text-danger-text">*</span>
  </label>
  <select
    formControlName="pharmacyRegion"
    class="border-border bg-surface-subtle placeholder-text-gray hover-border-input-border focus-border-gray-strong rounded-[6px] border-[1px] px-3 py-2 text-[14px] focus:bg-white focus:outline-none"
    [class.border-red-500]="
      pharmacyForm().get('pharmacyRegion')?.invalid && pharmacyForm().get('pharmacyRegion')?.touched
    ">
    <option disabled value="" i18n="@@selectRegion">Select Region</option>
    @for (region of regions(); track region.id) {
      <option [value]="region.id">
        {{ isArabic() ? region.titleAr : isEnglish() ? region.titleEn : "" }}
      </option>
    }
  </select>
  @if (pharmacyForm().get("pharmacyRegion")?.invalid && pharmacyForm().get("pharmacyRegion")?.touched) {
    <span class="text-danger-text text-[12px]">
      @if (pharmacyForm().get("pharmacyRegion")?.errors?.["required"]) {
        <span i18n="@@regionRequired">Region is required</span>
      }
    </span>
  }
</div>
